<script lang="ts">
  import { onMount } from 'svelte';
  import { api, ApiError } from '../lib/api';
  import ActivityRow from './ActivityRow.svelte';
  import type { ActivityPublic, UserLink } from '../../../shared/types';

  interface Props {
    username: string;
    onBack?: () => void;
  }
  let { username, onBack }: Props = $props();

  let displayName: string | null = $state(null);
  let links: UserLink[] = $state([]);
  let activities: ActivityPublic[] = $state([]);
  let loading = $state(true);
  let notFound = $state(false);
  let error: string | null = $state(null);

  onMount(async () => {
    try {
      const res = await api.publicList(username);
      displayName = res.display_name;
      links = res.links;
      activities = res.activities;
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) notFound = true;
      else error = 'Kunne ikke laste listen.';
    } finally {
      loading = false;
    }
  });
</script>

<section aria-label="Offentlig liste">
  {#if onBack}
    <div class="row" style="justify-content: space-between; margin-bottom: 1rem;">
      <button type="button" onclick={onBack}>← Tilbake</button>
    </div>
  {/if}

  {#if loading}
    <p class="muted">Laster …</p>
  {:else if notFound}
    <div class="card">
      <h2>Fant ikke listen</h2>
      <p class="muted">
        Brukernavnet finnes ikke, eller eieren har ikke skrudd på den offentlige listen.
      </p>
    </div>
  {:else if error}
    <p class="error">{error}</p>
  {:else}
    <h2 style="font-size: 1.75rem; margin-top: 0.5rem;">{displayName?.trim() || username}</h2>
    <p class="muted">Offentlige vinteraktiviteter</p>

    {#if links.length}
      <!-- rel="noopener" because we don't want the opened tab to be able to
           script into our window via opener; "ugc" tells search engines this
           is user-generated content (mild SEO hygiene + spam signal). -->
      <p class="row" style="gap: 0.5rem; margin: 0.5rem 0 1rem;">
        {#each links as link (link.id)}
          <a href={link.url} target="_blank" rel="noopener noreferrer ugc"
             class="tag" style="text-decoration: none; color: inherit;">
            {link.label} ↗
          </a>
        {/each}
      </p>
    {/if}

    {#if !activities.length}
      <p class="muted">Ingen offentlige aktiviteter ennå.</p>
    {/if}
    {#each activities as a (a.id)}
      <ActivityRow activity={a} onDeleted={() => {}} />
    {/each}
  {/if}
</section>
